import { cx } from '@clutch-creator/bridge';

export default (props, vars) =>
  cx(
    props?.['className'],
    props?.['error'] ? 'input-error-state' : undefined,
    !!props?.['disabled'] && 'disabled'
  );
